import styled from "styled-components";

export const ApproveRejectButton = styled.button`
  background-color: ${({ type, theme }) =>
    type === 'approve' ? '#EDF8FE' : '#EDF8FE'};
  color: ${({ type, theme }) => (type === 'approve' ? "green" : 'red' )};
  border: ${({ type }) => (type === 'approve' ? '1px solid green' : '1px solid red')};
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: ${({ theme, type }) =>
    type == 'approve' ? theme.fontWeights.bold : '500'};
  cursor: pointer;
  transition: background-color 0.3s ease;

  /* hover */
  &:hover {
    background-color: ${({ type, theme }) =>
      type === 'approve' ? '#EDF8FE' : '#EDF8FE'};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.main.gray};
    cursor: not-allowed;
  }
`;
